import { useState } from 'react';
import { WbGrid, WbGridCol, WbGridRow, WbSelect, WbText } from '@workbench/react';
import { useTranslation } from 'react-i18next';

import PanelHeader from '../Common/PanelHeader';
import VimdtAccordion from '../Common/VimdtAccordion';
import Image360ViewContainer from './Image360ViewContainer';

function Image360View({ images }) {
	const { t } = useTranslation();
	const [currentVin, setCurrentVin] = useState(Object.keys(images)[0]);
	const [panels, setPanels] = useState([]);

	const selectableVins = Object.keys(images).filter((vin) =>
		images[vin].some((img) => 'title' in img && img.title.startsWith('EXT'))
	);

	const content = (
		<>
			<WbGrid fullWidth>
				<WbGridRow>
					<WbGridCol mq1={12} mq3={3}>
						<WbText size="s">{t('vimdt.imagesTab.imageCompose.selectVIN')}</WbText>
					</WbGridCol>
					<WbGridCol mq1={12} mq3={9}>
						<WbSelect compact>
							<select
								aria-label={t('vimdt.imagesTab.imageCompose.selectVIN')}
								value={currentVin}
								onChange={(event) => setCurrentVin(event.target.value)}
							>
								{selectableVins.map((vin) => (
									<option key={vin} value={vin}>
										{vin}
									</option>
								))}
							</select>
						</WbSelect>
					</WbGridCol>
				</WbGridRow>
			</WbGrid>
			<Image360ViewContainer images={images} currentVin={currentVin} />
		</>
	);

	return (
		<VimdtAccordion
			activeKeys={panels}
			onChange={setPanels}
			items={[
				{
					key: '360',
					header: (
						<PanelHeader
							headerName={t('vimdt.imagesTab.image360View.title')}
							description={t('vimdt.imagesTab.image360View.description')}
						/>
					),
					content,
				},
			]}
		/>
	);
}

export default Image360View;
